import z from "zod";

export const addSupplierFormSchema = z.object({
  supplierName: z.string(),
  category: z.string(),
  region: z.string(),
  timeZone: z.string(),
  defaultLeadTimeBand: z.string().optional(),
  topItems: z.preprocess((val) => {
    if (typeof val === "string") {
      return val
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    }
    return val;
  }, z.array(z.string())),
  paymentTerms: z.string().optional(),
  incoTerms: z.string().optional(),
  currency: z.string().optional(),
  certifications: z.preprocess((val) => {
    if (typeof val === "string") {
      return val
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    }
    return val;
  }, z.array(z.string())),
  contactName: z.string(),
  contactEmail: z.string(),
  notes: z.string().optional(),
});
export type AddSupplierFormData = z.infer<typeof addSupplierFormSchema>;

export type LastTenOrderOutcomes = {
  id: number;
  po: string;
  part: string;
  needByDate: string;
  promisedDate: string;
  deliveredDate: string;
  days: string;
  headsUp: "Yes" | "No";
};

export type TypicalLeadTime = {
  id: number;
  itemName: string;
  leadTime: string;
};

export type OpenOrdersSupplier = {
  id: number;
  supplier: string;
  urgency: number;
  open: number;
  late: number;
  unconfirmed: number;
  due: number;
  headsUp: string;
  partial: string;
  aging: number;
  type: string;
  workOrder: string;
};

export const saveFulfillmentFormSchema = z.object({
  // Schedule
  needByDate: z.string(),
  promisedDate: z.string(),
  deliveredDate: z.string(),
  status: z.string(),

  // Receiving and quality
  quantityOrdered: z.coerce.number(),
  quantityReceived: z.coerce.number(),
  quantityAccepted: z.coerce.number(),
  quantityRejected: z.coerce.number(),
  defectType: z.string(),
  capaOrIssueId: z.string(),

  // Heads-up & Communication
  supplierGaveHeadsUpBeforeDelay: z.boolean(),
  headsUpReason: z.string(),
  headsUpDate: z.string(),

  // Pricing
  unitPrice: z.coerce.number(),
  currency: z.string(),
});
export type SaveFulfillmentFormData = z.infer<typeof saveFulfillmentFormSchema>;
